/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import { gql, useApolloClient } from '@apollo/client';


const GQL_GET_CART = gql`
  query CartById($id: ID) {
    me {
      id
      carts(cartId: $id) {
        id
        promotionCodes {
          code
        }
        grandTotal {
          ...Currency
        }
        totalProductPrice {
          ...Currency
        }
        totalShippingCharge {
          ...Currency
        }
        totalAdjustment {
          ...Currency
        }
        totalShippingTax {
          ...Currency
        }
        totalSalesTax {
          ...Currency
        }
        adjustments {
          title
          type
          amount {
            ...Currency
          }
        }
        shippingInfo {
          shipMode {
            id
            identifier
          }
          pickupInStore {
            id
            name
          }
          shippingAddress {
            id
            country
            zip
          }
        }
        lineItems {
          id
          quantity
          partnumber
          linePrice {
            ...Currency
          }
          unitPrice {
            ...Currency
          }
          product {
            id
            type
            thumbnail
            name
            partnumber
            price {
              list {
                ...Currency
              }
              offer {
                ...Currency
              }
            }
          }
        }
      }
    }
  }

  fragment Currency on CmmMoney {
    value
    currency
  }
`;

// TODO: There's some opportunity to reduce duplication as some of this is handled in useCartModification
export const useCheckout = () => {
  const apolloClient = useApolloClient();

  return {
    
    getCartForSummary: async (id) => {
      return apolloClient.query({
        query: GQL_GET_CART,
        fetchPolicy: 'network-only',
        variables: { id , context:{clientName:"cart"}}
      });
    }
  };
};
